<template lang="html">
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body fluid="xl">
          <b-form @submit.stop.prevent="onSubmit">
            <b-row>
              <b-col lg="12">
                <b-alert show variant="light">Overdues By Selection Periods Repor</b-alert>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <hr/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Select Period" label-for="selectionPeriod">
                  <v-select ref="selectionPeriod" id="selectionPeriod" name="selectionPeriod" :reduce="selection => selection" label="name" :class="{ danger: $v.form.selectionPeriod.$error }" @search:blur="$v.form.selectionPeriod.$touch()" :state="validateState('selectionPeriod')"  aria-describedby="liveFeedbackselectionPeriod"  :options="selectionPeriods"  v-model="$v.form.selectionPeriod.$model" ></v-select>
                  <span v-show="$v.form.selectionPeriod.$error" class="danger-span">
                    This is required field
                  </span>
                  <b-form-invalid-feedback id="liveFeedbackselectionPeriod">
                    This is a required field.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <b-button ref="submitButton" type="submit" variant="success" :disabled="$v.form.$invalid">
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
      </b-card-body>
    </b-card>
    <b-card v-if="reportData!=null && Object.keys(reportData).length > 0">
        <ag-grid-vue class="ag-theme-balham"
          :gridOptions="gridOptions"
          id="AmountDueBySelectionGrid"
          :rowData="reportData"
          :pagination="true"
          :paginationPageSize="50"
          :suppressNoRowsOverlay="true"
          :floatingFilter="true"
          @gridReady="gridReady">
        </ag-grid-vue>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {AgGridVue} from "ag-grid-vue";
  import VueLodash from 'vue-lodash'
  import map from 'lodash/map'
  import {
    mapState,
    mapActions
  } from 'vuex'

  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  const formShape = {
    selectionPeriod: null
  }
  export default {
    name: 'AmountDueBySelection',
    components: {
      AgGridVue
    },
    data: function() {
      return {
        selectionPeriods: [
            {name: 'Current', value: {fromperiod: 0, toperiod: 0, interval: 0, isOlder: false, isCurrent: true}},
            {name: '1-3 Months', value: {fromperiod: 3, toperiod: 0, interval: 0, isOlder: false, isCurrent: false}},
            {name: '3-6 Months', value: {fromperiod: 6, toperiod: 6, interval: 3, isOlder: false, isCurrent: false}},
            {name: '6-9 Months', value:{fromperiod: 9, toperiod: 9, interval: 3, isOlder: false, isCurrent: false}},
            {name: '9-12 Months', value:{fromperiod: 12, toperiod: 12, interval: 3, isOlder: false, isCurrent: false}},
            {name: 'Older than 12 Months', value: {fromperiod: 12, toperiod: 0, interval: 0, isOlder: true, isCurrent: false}}
          ],
        form: Object.assign({}, formShape),
        reportData: null,
        gridOptions: {
          context: {
            componentParent: this
          },
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agNumberColumnFilter',
          },
          columnDefs: [
            {headerName: 'Profile Name', field: 'profilename', filter: 'agTextColumnFilter', minWidth: 200},
            {headerName: 'Address', field: 'houseno', filter: 'agTextColumnFilter', minWidth: 200},
            {headerName: 'Total Amout Due', field: 'total',minWidth: 200}
          ]
       }
      }
    },
    computed: {
      isValid() {
        this.$v.$touch();
        return !this.$v.form.$anyError
      },

    },
    validations: {
      form: {
        selectionPeriod: {
          required
        }
      }
    },
    methods:{
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      },
      onSubmit() {
          if(this.isValid){
          this.$nextTick(() => {
            let params = {
                name: this.$v.form.selectionPeriod.$model.name,
                fromperiod: this.$v.form.selectionPeriod.$model.value.fromperiod,
                toperiod: this.$v.form.selectionPeriod.$model.value.toperiod,
                interval: this.$v.form.selectionPeriod.$model.value.interval,
                isOlder: this.$v.form.selectionPeriod.$model.value.isOlder,
                isCurrent: this.$v.form.selectionPeriod.$model.value.isCurrent
            };            
            this.$store.dispatch('electrical/getAmountDueBySelectionPeriod', params)
              .then((response) => {
                if(response.data.success == false){
                    this.showErrorMsg({
                      message: response.data.error
                    });
                }
                else{
                  this.reportData = response.data.data;
                  if(Object.keys(this.reportData).length > 0){
                    this.showSuccessMsg({
                      message: 'Records Retrieved successfully.'
                    });
                  }
                  else{
                    this.showSuccessMsg({
                      message: 'No Records Found for given criteria.'
                    });
                  }


                }
              })
              .catch((error) => {
                if (error.response.status == 400) {
                  this.showErrorMsg({
                    message: error.response.data.message
                  })
                }
                else if (error.response.status == 422){
                    this.showErrorMsg({
                      message: error.response.data.message
                    });

                }
                else {
                  this.showErrorMsg({message: "Something went wrong. Please contact administrator."})
                }
              })

          })
        }
      },
      gridReady(){
         this.gridOptions.api.sizeColumnsToFit();
      },
      onReset() {
        this.form = formShape
        this.$nextTick(() => {
          this.$v.$reset()
        })
      },
    },
  }
</script>

<style lang="css">
</style>
